<!-- 组织信息 -->
<template>
  <div class="organization-info-view">
    <p class="info-title">核心团队信息&nbsp;&nbsp;{{ zcTeamList.length }}</p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="zcTeamList"
          border
          style="width: 870px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="talentId"
            label="人才实体编号"
            align="center"
            width="165"
          ></el-table-column>

          <el-table-column label="人员头像" align="center" width="199">
            <template v-slot="{ row }">
              <el-image
                :src="getSeverFileUrl(row.headPortrait)"
                class="headerImg"
              />
            </template>
          </el-table-column>

          <el-table-column
            prop="userName"
            label="人员姓名"
            align="center"
            width="224"
          >
          </el-table-column>

          <el-table-column prop="userPosition" label="人员职务" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <p class="info-title">招聘信息&nbsp;&nbsp;{{ zcRecruitmentList.length }}</p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="zcRecruitmentList"
          border
          style="width: 870px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="recruitmentId"
            label="招聘数据编号"
            align="center"
            width="160"
          ></el-table-column>

          <el-table-column
            prop="recruitmentName"
            label="职位名称"
            align="center"
            width="129"
          >
          </el-table-column>

          <el-table-column
            prop="recruitmentBrief"
            label="职位简介"
            align="center"
            width="368"
          >
          </el-table-column>

          <el-table-column
            prop="recruitmentResource"
            label="数据的来源"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getOrganizationInfo } from "@/api/customCompany.js";
export default {
  data() {
    return {
      zcRecruitmentList: [], // 招聘信息
      zcTeamList: [], // 核心团队信息
      isInit: false
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getOrganizationInfo({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.isInit = true;

          if (res.data && Array.isArray(res.data.zcRecruitmentList)) {
            this.zcRecruitmentList = res.data.zcRecruitmentList;
          }

          if (res.data && Array.isArray(res.data.zcTeamList)) {
            this.zcTeamList = res.data.zcTeamList;
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.organization-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;

    .table-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: block;
        margin-right: 4px;
        width: 7px;
        height: 7px;
        background-color: #1e9fff;
        border-radius: 50%;
      }
    }
  }
}
</style>
